import colors from './colors';

export const S = {
    fontSize: 11,
    fontFamily: `'Poppins', sans-serif`,
    color: colors.black
}

export const SM = {
    fontSize: 12,
    fontFamily: `'Poppins', sans-serif`,
    color: colors.black
}

export const M = {
    fontSize: 14,
    fontFamily: `'Poppins', sans-serif`,
    color: colors.black
}

export const MM = {
    fontSize: 17,
    fontFamily: `'Poppins', sans-serif`,
    color: colors.black
}

export const ML = {
    fontSize: 19,
    fontFamily: `'Poppins', sans-serif`,
    color: colors.black
}

export const L = {
    fontSize: 23,
    color: colors.white,
    fontFamily: `'Poppins', sans-serif`,
    letterSpaceing: 0
}

export const XL = {
    fontSize: 36,
    color: colors.white,
    fontFamily: `'Poppins', sans-serif`,
    letterSpaceing: 0
}

export const Light = {
    fontWeight: 300,
}

export const Regular = {
    fontWeight: 400,
}

export const Medium = {
    fontWeight: 500,
}

export const SemiBold = {
    fontWeight: 600,
}

export const Bold = {
    fontWeight: 700,
}

